import { Time } from '@app/domain/Time'
import { Contact } from './Contact'
import { DateTime } from 'luxon'
import { environment } from '@environments/environment'

export class DiaryNote {

    constructor(
        public id: string,
        public startDate: Date,
        public endDate: Date,
        public note: string,
        public title: string | null,
        public startTime: Time | null,
        public durationMinutes: number | null,
        public contact: Contact | null,
        public isPublic: boolean
    ) { }

    occursOnDate(date: Date): boolean {
        const start = DateTime.fromJSDate(this.startDate)
            .setZone(environment.assumedVenueTimeZone)
        const end = DateTime.fromJSDate(this.endDate)
            .setZone(environment.assumedVenueTimeZone)
        const targetDateStart = DateTime.fromJSDate(date)
            .setZone(environment.assumedVenueTimeZone)
            .startOf('day')
        const targetDateEnd = targetDateStart
            .setZone(environment.assumedVenueTimeZone)
            .endOf('day')
        return start <= targetDateEnd && end >= targetDateStart
    }

    startDateTime(): Date | null {
        if (!this.startTime) {
            return null
        }
        const startDate = new Date(this.startDate)
        startDate.setHours(this.startTime.hours)
        startDate.setMinutes(this.startTime.minutes, 0, 0)
        return startDate
    }

    endDateTime(): Date | null {
        if (!this.startTime) {
            return null
        }
        if (!this.durationMinutes) {
            return null
        }
        const endDate = new Date(this.endDate)
        endDate.setHours(this.startTime.hours)
        endDate.setMinutes(this.startTime.minutes + this.durationMinutes, 0, 0)
        return endDate
    }
}
